import { TableCell, TableHead, TableRow } from '@mui/material';

export default function PhoneAndInternetTableHead() {
    return (
        <TableHead>
            <TableRow>
                <TableCell sx={{ pl: 0 }}>EXPENSE</TableCell>
                <TableCell align="right">MONTHLY COST</TableCell>
                <TableCell />
                <TableCell align="right">MULTIPLIER</TableCell>
                <TableCell />
                <TableCell align="right" sx={{ pr: 0 }}>
                    REIMBURSABLE
                </TableCell>
            </TableRow>
        </TableHead>
    );
}
